import { useTranslation } from 'react-i18next'
import { DialogDescription } from '@/components/ui/dialog'
import { MAX_UPLOAD_FILE_SIZE_MB } from '@/shared/lib/uploadGuardrails'

type ProductSourceUploadDialogInstructionsProps = {
  variant: 'pick' | 'review'
  context?: 'addSources' | 'fromDocuments'
}

export function ProductSourceUploadDialogInstructions({
  variant,
  context = 'addSources',
}: ProductSourceUploadDialogInstructionsProps) {
  const { t } = useTranslation('productCatalog')
  const uploadLimitHint = { maxSizeMb: MAX_UPLOAD_FILE_SIZE_MB }

  let introKey = 'sources.addDialog.descriptionIntro'
  if (variant === 'review') {
    introKey = 'sources.addDialog.review.descriptionIntro'
  } else if (context === 'fromDocuments') {
    introKey = 'dialog.fromDocuments.descriptionIntro'
  }

  return (
    <DialogDescription className='space-y-2'>
      <span className='block'>{t(introKey)}</span>
      <ul className='list-disc space-y-1 ps-5'>
        <li>{t('sources.addDialog.requirementFormats')}</li>
        <li>{t('sources.addDialog.requirementMaxSize', uploadLimitHint)}</li>
        {variant === 'review' && (
          <li>{t('sources.addDialog.review.requirementUnencrypted')}</li>
        )}
      </ul>
      {variant === 'review' && (
        <span className='block'>
          {t('sources.addDialog.review.descriptionFooter')}
        </span>
      )}
    </DialogDescription>
  )
}
